import { h } from 'preact';
import { openLink } from '../../lib/Hyperlinks';
import './index.less';
import { showPoweredByResellship } from '../../lib/CompanyExperiments';

export default ({ className }) => {
  const isPoweredByResellship = showPoweredByResellship();
  const onClickHandler = () =>
    openLink({
      callNativeHandler: true,
      url: 'https://form.typeform.com/to/Odh5q4gt',
      analyticsName: 'powered_by_resellship'
    });

  return (
    isPoweredByResellship && (
      <div className={`powered-by-link ${className || ''}`}>
        <a className="link" rel="presentation" onClick={onClickHandler}>
          Powered By Resellship
        </a>
      </div>
    )
  );
};
